import { Avatar, Box } from "@material-ui/core";
import { TeamMember } from "../../../@types/custom";
import * as React from "react";
import { formatLocalPhoneNumber } from "../../../services/virtualNumbers";

type AutocompleteTagProps =
  | {
      member: string;
      myTeam: TeamMember[];
      /** Virtual number → customer-defined tag naming the lead source it's used for. */
      tagsByNumber?: Record<string, string>;
      children?: never;
    }
  | {
      member?: never;
      myTeam?: never;
      tagsByNumber?: never;
      children: React.ReactNode;
    };

export function AutocompleteTag(props: AutocompleteTagProps): React.ReactElement {
  const { member, myTeam, children, tagsByNumber = {} } = props;

  if (children) {
    return (
      <Box
        display="flex"
        alignItems="center"
        bgcolor="grey.200"
        px={2}
        py={0.5}
        borderRadius="20px"
      >
        {children}
      </Box>
    );
  }

  const [email, number] = member.split("|");
  const owner = myTeam.find((m) => m.email === email);
  const { ownerFirstName, ownerFullName, photoURL } = owner;
  // Prefer the number's tag over its digits — that's the label the customer
  // recognises. The full number stays in the option list and the tooltip.
  const tag = tagsByNumber[number];
  return (
    <Box
      display="flex"
      alignItems="center"
      bgcolor="grey.200"
      pr={1}
      mb="4px"
      borderRadius="20px"
      title={`${ownerFullName ?? email} - ${formatLocalPhoneNumber(number)}`}
    >
      <Box>
        <Avatar sx={{ width: "28px", height: "28px", mr: 1 }} alt={ownerFullName} src={photoURL} />
      </Box>
      <Box fontSize={14}>
        {ownerFirstName ?? ownerFullName?.split(" ")[0] ?? email} -{" "}
        {tag ?? formatLocalPhoneNumber(number)}
      </Box>
    </Box>
  );
}
